// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { copyToClipboard } from '@Helpers/copy';
import { useLocalMessage } from '@Helpers/locale';
import React, { ReactElement, ReactNode } from 'react';

import './CopyValue.scss';

interface CopyValueProps {
    children: ReactNode;
    value: any;
    disabled?: boolean;
}
export const CopyValue = ({ value, children, disabled }: CopyValueProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <span className="copy-value">
            {children}
            {!disabled && (
                <ICONS.CopyOutlined
                    className="copy-value__icon"
                    onClick={!disabled ? () => copyToClipboard(value, i('notification.copy')) : undefined}
                    title={i('general.copy')}
                />
            )}
        </span>
    );
};
